import { render, staticRenderFns } from "./TextInformativeModalUnemployed.vue?vue&type=template&id=52cfab76&scoped=true&"
import script from "./TextInformativeModalUnemployed.vue?vue&type=script&lang=js&"
export * from "./TextInformativeModalUnemployed.vue?vue&type=script&lang=js&"
import style0 from "./TextInformativeModalUnemployed.vue?vue&type=style&index=0&id=52cfab76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cfab76",
  null
  
)

export default component.exports